var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1850_41633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V11H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 0L6.97813 4.14792L12.2937 0H14V1.42083L8.75 5.52292L14 9.60208V11H12.25L7 6.89792L1.77188 11H0V9.625L5.22813 5.54583L0 1.46667V0H1.64062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.275 6.43958L14 10.0833V11L8.07187 6.43958H9.275ZM5.25 6.89792L5.38125 7.7L1.18125 11H0L5.25 6.89792ZM14 0V0.06875L8.55312 4.37708L8.59688 3.36875L12.9062 0H14ZM0 0L5.22813 4.03333H3.91562L0 0.9625V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27187 0V11H8.77187V0H5.27187ZM0 3.66667V7.33333H14V3.66667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.42292V6.62292H14V4.42292H0ZM5.97187 0V11H8.07187V0H5.97187Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1850_41633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsLang);
export default __webpack_public_path__ + "static/media/es-lang.0e43df8b250d14d24f259f6cd79a599f.svg";
export { ForwardRef as ReactComponent };